import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <span className="logo-text">Saner</span>
              <span className="logo-accent">Consulting</span>
            </div>
            <p className="footer-description">
              Transforming businesses through innovative AI solutions and strategic consulting.
            </p>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Services</h3>
            <ul className="footer-links">
              <li><Link to="/services">Transformation Services</Link></li>
              <li><Link to="/services">Process Optimization</Link></li>
              <li><Link to="/services">Change Management</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Company</h3>
            <ul className="footer-links">
              <li><Link to="/ai-journey">AI for You</Link></li>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/youtube">YouTube</Link></li>
              <li><Link to="/contact">Contact</Link></li>
              <li><button className="cookie-settings-btn" onClick={() => {
                if (window.showCookiePreferences) {
                  window.showCookiePreferences();
                }
              }}>Cookie Settings</button></li>
            </ul>
          </div>

          <div className="footer-section">
            <h3 className="footer-title">Connect</h3>
            <div className="social-links">
              <a href="https://www.linkedin.com/in/gareth-saner/" className="social-link" aria-label="LinkedIn" target="_blank" rel="noopener noreferrer">LinkedIn</a>
              <a href="https://www.youtube.com/@Saner-Youtube" className="social-link" aria-label="YouTube" target="_blank" rel="noopener noreferrer">YouTube</a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Saner Consulting Limited. All rights reserved.</p>
          <div className="privacy-links">
            <Link to="/privacy-policy">
              Privacy Policy
            </Link>
            <span>|</span>
            <Link to="/cookie-policy">
              Cookie Policy
            </Link>
            <span>|</span>
            <button onClick={() => {
              if (window.showCookiePreferences) {
                window.showCookiePreferences();
              }
            }}>
              Cookie Settings
            </button>
            <span>|</span>
            <span>Company No: 10471658</span>
            <span>|</span>
            <span>VAT: 255130531</span>
          </div>
          <p style={{fontSize: '0.8rem', marginTop: '0.5rem'}}>
            We are committed to protecting your privacy and only use essential cookies for website functionality. 
            No personal data is tracked or shared with third parties.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
